import React from 'react';
import { Box } from '@mui/system';

export const HorizontalSpaceBetweenLayout = ({
  children
}: {
  children: JSX.Element;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      {children}
    </Box>
  );
};
